import { render, staticRenderFns } from "./IconMicrophoneSolid.vue?vue&type=template&id=a959a868"
import script from "./IconMicrophoneSolid.vue?vue&type=script&lang=js"
export * from "./IconMicrophoneSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports